export const MISMATCHED_REQUEST_FAILED =
  "There was an error retrieving mismatched trades. The request failed.";
export const MISBILLED_REQUEST_FAILED =
  "There was an error retrieving misbilled trades. The request failed.";
export const TEMPORARILY_UNAVAILABLE =
  "Sorry, this service is temporarily unavailable. Please check back later.";
